import PropTypes from 'prop-types';
import { useContext } from 'react';
import { PLAYER_MANAGER_ENABLED } from 'src/common/constants/experiments/config';
import { WHY_ADS } from 'src/common/constants/localizations/ads';
import useExperiment from 'src/common/hooks/useExperiment';
import { LocationAndLocalizationContext } from 'src/common/providers/LocationAndLocalizationProvider';
import {
  MIDROLL_SLOT_NAME,
  MINT_VIDEO_AD_CONTAINER_ID,
  PREROLL_SLOT_NAME,
} from './constants/displayAds';
import VideoAdMediaButtons from './controls/VideoAdMediaButtons';
import VideoAdCountdown from './VideoAdCountdown';
import LegacyVideoAdSlot, { VideoAdSlot } from './VideoAdSlot';
import css from './videoAd.module.scss';

export default function VideoAdViewContainer({ breakpoint, height }) {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const isPlayerManagerEnabled = useExperiment(PLAYER_MANAGER_ENABLED);

  return (
    <>
      <div data-testid="videoAdTopMessageContainer" className={css.videoAdTopMessageContainer}>
        <div className={css.topOfAdMessage}>{getLocalizedText(WHY_ADS)}</div>
      </div>
      <div className={css.videoAdSlotContainer}>
        {isPlayerManagerEnabled
          ? <VideoAdSlot />
          : <LegacyVideoAdSlot
              id={MINT_VIDEO_AD_CONTAINER_ID}
              slotNames={[MIDROLL_SLOT_NAME, PREROLL_SLOT_NAME]}
              breakpoint={breakpoint}
              deregisterDisplaySlot={false}
              height={height}
            />}
      </div>
      <div className={css.videoAdMediaButtonsContainer}>
        <VideoAdMediaButtons />
      </div>
      <div className={css.videoAdCountdownContainer}>
        <VideoAdCountdown />
      </div>
    </>
  );
}

VideoAdViewContainer.propTypes = {
  breakpoint: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};
